var map = {
	"./en/instructions-id-back": [
		9623,
		9623
	],
	"./en/instructions-id-back.json": [
		9623,
		9623
	],
	"./en/instructions-id-front": [
		619,
		619
	],
	"./en/instructions-id-front.json": [
		619,
		619
	],
	"./en/instructions-orc": [
		8698,
		8698
	],
	"./en/instructions-orc.json": [
		8698,
		8698
	],
	"./en/instructions-passport": [
		7706,
		7706
	],
	"./en/instructions-passport.json": [
		7706,
		7706
	],
	"./en/instructions-selfie": [
		6472,
		6472
	],
	"./en/instructions-selfie.json": [
		6472,
		6472
	],
	"./es/instructions-id-back": [
		1282,
		1282
	],
	"./es/instructions-id-back.json": [
		1282,
		1282
	],
	"./es/instructions-id-front": [
		4036,
		4036
	],
	"./es/instructions-id-front.json": [
		4036,
		4036
	],
	"./es/instructions-orc": [
		859,
		859
	],
	"./es/instructions-orc.json": [
		859,
		859
	],
	"./es/instructions-passport": [
		1469,
		1469
	],
	"./es/instructions-passport.json": [
		1469,
		1469
	],
	"./es/instructions-selfie": [
		6819,
		6819
	],
	"./es/instructions-selfie.json": [
		6819,
		6819
	],
	"./it/instructions-id-back": [
		4381,
		4381
	],
	"./it/instructions-id-back.json": [
		4381,
		4381
	],
	"./it/instructions-id-front": [
		4033,
		4033
	],
	"./it/instructions-id-front.json": [
		4033,
		4033
	],
	"./it/instructions-orc": [
		4664,
		4664
	],
	"./it/instructions-orc.json": [
		4664,
		4664
	],
	"./it/instructions-passport": [
		8608,
		8608
	],
	"./it/instructions-passport.json": [
		8608,
		8608
	],
	"./it/instructions-selfie": [
		6126,
		6126
	],
	"./it/instructions-selfie.json": [
		6126,
		6126
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1917;
module.exports = webpackAsyncContext;